function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled, css } from 'styled-components';
import { gradients } from '../../abstracts';
export const StyledImage = styled.div.withConfig({
  componentId: "aui__sc-6a2a58-0"
})(["position:relative;overflow:hidden;border-radius:var(--aui-border-radius-200);display:flex;", " ", " ", " ", " ", " img,picture{width:100%;height:100%;object-fit:", ";}"], ({
  $width,
  $height
}) => ($width || $height) && `flex-shrink: 0;`, ({
  $width
}) => $width && `width: ${$width};`, ({
  $height
}) => $height && `height: ${$height};`, ({
  $aspectRatio
}) => $aspectRatio && `aspect-ratio: ${$aspectRatio};`, ({
  $variant
}) => $variant === 'product' && css(["background:", ";padding:var(--aui-spacing-200);"], gradients.lightAngle1), ({
  $variant
}) => $variant === 'product' ? `contain` : 'cover');
export const Image = ({
  width,
  height,
  aspectRatio,
  variant,
  ...props
}) => /*#__PURE__*/React.createElement(StyledImage, _extends({
  $width: width,
  $height: height,
  $aspectRatio: aspectRatio,
  $variant: variant
}, props));